import { withTranslation } from "next-i18next";

function FooterLegal({ t }) {
  return (
    <div className="d-flex gap-2 align-items-center justify-content-between footer-legal">
      <a
        href={t("common:footer.conditions.link")}
        className="link-primary footer-legal-link"
        title={t("common:footer.conditions")}
      >
        {t("common:footer.conditions.text")}
      </a>
      <p className="mb-0 font-size-sm text-middle-gray">|</p>
      <a
        href={t("common:footer.mentions.link")}
        className="link-primary footer-legal-link"
        title={t("common:footer.legal")}
      >
        {t("common:footer.mentions.text")}
      </a>
    </div>
  );
}

export default withTranslation("common")(FooterLegal);
